import { render } from "./WorkAN.vue?vue&type=template&id=65cd08b0&scoped=true"
import script from "./WorkAN.vue?vue&type=script&lang=js"
export * from "./WorkAN.vue?vue&type=script&lang=js"

import "./WorkAN.vue?vue&type=style&index=0&id=65cd08b0&scoped=true&lang=css"

import exportComponent from "/home/adrien/perso/Projets/new-portfolio/vuejs-tailwind-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cd08b0"]])

export default __exports__